import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_SCHEDULE_TIMING_CUSTOMIZE,
    saveScheduleTimingCustomizeFail,
    saveScheduleTimingCustomizeSuccess
} from '../action/saveScheduleTimingCustomizeAction'

// api 
import saveScheduleTimingCustomizeApi from '../api/saveScheduleTimingCustomizeApi'

export function* saveScheduleTimingCustomizeSaga(action) {
    try {
      const response = yield call(() => saveScheduleTimingCustomizeApi(action.params));
      if (response.data.status === 1) {
        console.log(response.data)
        yield put(saveScheduleTimingCustomizeSuccess(response, action));
      } else {
        yield put(saveScheduleTimingCustomizeFail(response, action));
      }
    } catch (e) {
      yield put(saveScheduleTimingCustomizeFail(e.response, action));
    }
  }
  
  export default function* mySaga() {
    yield takeLatest(SAVE_SCHEDULE_TIMING_CUSTOMIZE, saveScheduleTimingCustomizeSaga);
  }
  
 